import { MainDomain, apiGet } from 'api';

const clients = {
    getAll: async () => {
        // const data = apiGet(`https://api.amasocial.co.za/api/client/getall`);
        const data = apiGet(`https://crm-api.${MainDomain}.co.za/api/client/getall`);
        return data;
    }
}

export default clients;